import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Service, inject } from '@angular/core';
import { Router } from '@angular/router';
import { IEmployee } from 'app/core/models/employee/employee';
import { environment } from 'environments/environment';
import { Observable, Subject, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { IData } from '../../models/api/data';
import { IError } from '../../models/error/error';
import { IUser, IUserExist } from '../../models/user/user';
import { IMedia, IUploadFile, IUploadFiles } from 'app/core/models/media/media';

@Service()
export class UserService {
    private readonly router = inject(Router);
    private readonly httpClient = inject(HttpClient);

    /** Inserted by Angular inject() migration for backwards compatibility */
    constructor(...args: unknown[]);

    constructor() {}

    private _userObservable = new Subject<IUser>();

    get userObservable(): Observable<IUser> {
        return this._userObservable.asObservable();
    }

    // CLINIC
    me(isObservable = false): Observable<IUser> | void {
        const baseUrl = ['clinic', 'admin', 'user', 'me'];

        const url = this.router.createUrlTree(baseUrl);

        const parsedUrl = `${environment.apiUrl}/${environment.apiVersion}${url}`;

        if (isObservable) {
            return this.httpClient.get(parsedUrl, { responseType: 'json' }).pipe(
                map((res: IData<IUser>) => {
                    return res.data;
                }),
                catchError((error: HttpErrorResponse) => {
                    if (error.error instanceof ErrorEvent) {
                        return throwError(() => `Error: ${error.error.message}`);
                    }
                    const errorApi: IError = error.error.error;
                    return throwError(() => errorApi);
                }),
            );
        }

        // TODO -> Fazer o me sem observable
        this.httpClient
            .get(parsedUrl, { responseType: 'json' })
            .pipe(
                map((res: IData<IUser>) => {
                    return res.data;
                }),
                catchError((error: HttpErrorResponse) => {
                    if (error.error instanceof ErrorEvent) {
                        return throwError(() => `Error: ${error.error.message}`);
                    }
                    const errorApi: IError = error.error.error;
                    return throwError(() => errorApi);
                }),
            )
            .subscribe({
                next: (result) => {
                    this._userObservable.next(result);
                },
                error: (error) => {},
            });
    }

    uploadAvatar(data: IUploadFile): Observable<IData<IMedia>> {
        const { file, ...parameters } = data;
        const baseUrl = ['clinic', 'admin', 'user', 'avatar'];

        const formData: FormData = new FormData();
        formData.append('file', file);

        const url = this.router.createUrlTree(baseUrl, {
            queryParams: parameters,
        });

        const parsedUrl = `${environment.apiUrl}/${environment.apiVersion}${url}`;

        return this.httpClient.post<IData<IMedia>>(parsedUrl, formData).pipe(
            catchError((error: HttpErrorResponse) => {
                if (error.error instanceof ErrorEvent) {
                    return throwError(() => `Error: ${error.error.message}`);
                }
                const errorApi: IError = error.error.error;
                return throwError(() => errorApi);
            }),
        );
    }
}
